// extracted by mini-css-extract-plugin
export default {"activated":"activated_activated__YWHpd"};